(() => {
  const solidThreshold = 120;

  let announcementHeight = 0;

  const setAnnouncementHeight = () => {
    const announcement = document.querySelector('.announcement-bar-section');

    announcementHeight = announcement
      ? announcement.getBoundingClientRect().height
      : 0;

    document.documentElement.style.setProperty(
      '--hof-announcement-height',
      `${announcementHeight}px`
    );
  };

  const updateHeaderState = () => {
    const body = document.body;

    if (!body.classList.contains('hof-transparent-header-active')) {
      body.classList.remove(
        'hof-header-pinned',
        'hof-header-solid'
      );

      return;
    }

    if (window.scrollY < announcementHeight) {
      body.classList.remove(
        'hof-header-pinned',
        'hof-header-solid'
      );

      return;
    }

    body.classList.add('hof-header-pinned');

    if (window.scrollY >= announcementHeight + solidThreshold) {
      body.classList.add('hof-header-solid');
    } else {
      body.classList.remove('hof-header-solid');
    }
  };

  const initHofHeaderOverlay = () => {
    const hero = document.querySelector(
      '.hof-hero[data-hof-transparent-header="true"]'
    );

    const body = document.body;

    if (!body) return;

    setAnnouncementHeight();

    if (!hero) {
      body.classList.remove(
        'hof-transparent-header-active',
        'hof-header-pinned',
        'hof-header-solid'
      );

      body.style.removeProperty('--hof-overlay-header-color');

      return;
    }

    const headerColor =
      hero.getAttribute('data-hof-header-color') || '#ffffff';

    body.classList.add('hof-transparent-header-active');

    body.style.setProperty(
      '--hof-overlay-header-color',
      headerColor
    );

    updateHeaderState();
  };

  document.addEventListener(
    'DOMContentLoaded',
    initHofHeaderOverlay
  );

  window.addEventListener(
    'scroll',
    updateHeaderState,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    () => {
      setAnnouncementHeight();
      updateHeaderState();
    }
  );

  document.addEventListener(
    'shopify:section:load',
    initHofHeaderOverlay
  );

  document.addEventListener(
    'shopify:section:unload',
    initHofHeaderOverlay
  );

  document.addEventListener(
    'shopify:section:reorder',
    initHofHeaderOverlay
  );

  document.addEventListener(
    'shopify:section:select',
    initHofHeaderOverlay
  );
})();